const customerSettingsLinks: any[] = [
  {
    label: "MENU.CUSTOMERS_TYPE_PLURAL",
    capability: "show_customer_types_list",
    url: "/dashboard/customers-type",
    section: "administration", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
  {
    label: "MENU.CUSTOMERS_FTE_SUBJECT_TYPE_PLURAL",
    capability: "show_customer_subject_types_list",
    url: "/dashboard/fte-subject-type",
    section: "administration", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
  {
    label: "MENU.CUSTOMERS_TRACK_FINANCE_RELEVANCE_PLURAL",
    capability: "show_customer_financial_relevance",
    url: "/dashboard/customers-track-finance-relevance",
    section: "administration", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
  {
    label: "MENU.CUSTOMERS_SERVICES_TRACK_PLURAL",
    capability: "show_invoice_services_track_list",
    url: "/dashboard/services-track",
    section: "lists", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
  {
    label: "MENU.BANKS",
    capability: "show_menu_banks",
    url: "/dashboard/banks",
    section: "lists", // lists, update_data, administration, documents, notifications, manage_platform, user_permissions
  },
];
export default customerSettingsLinks;
